import { render, staticRenderFns } from "./ProfiloEdit.vue?vue&type=template&id=315d1b9c"
import script from "./ProfiloEdit.vue?vue&type=script&lang=js"
export * from "./ProfiloEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports